(function() {
  'use strict';
  
  angular
    .module('app.shell')
    .directive('marsInclude', marsInclude);
      
  marsInclude.$inject = ['$log'];
    
  function marsInclude($log) {
    $log = $log.getInstance('marsInclude');
    
    var directive = {
      restrict: 'A',
      scope: {
        vm: '&marsIncludeVm'
      },
      templateUrl: function(elem, attrs) {
        $log.debug('attrs: ', attrs);
        return attrs.marsInclude;
      }
    }
    return directive;
  }
  
})();